import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { makeStoreApiRequest, StoreApiResult } from '../utils';
import { CartRequest, CartResponse as CartV2Response } from 'lib/commerce/cart/types';

/** Website cart client routing all create/read/mutate through the unified POST /api/cart endpoint. */
export class CartApiService {
  constructor(private store: ShopifyStore) {}

  async mutateCart(body: CartRequest): Promise<StoreApiResult<CartV2Response>> {
    return makeStoreApiRequest(
      this.store,
      '/api/cart/',
      body as unknown as Record<string, unknown>,
    ) as Promise<StoreApiResult<CartV2Response>>;
  }
}
